const WAREHOUSE_TYPES_ARRAY = ['NTW', 'TR DC']
const WAREHOUSE_TYPES = {
  ntw: 'NTW',
  trdc: 'TR DC'
}

export {
  WAREHOUSE_TYPES_ARRAY,
  WAREHOUSE_TYPES
}